// extracted by mini-css-extract-plugin
export default {"bookmarkChip":"Pg_7_2_bookmarkChip__LhVWe"};